<se-fe-modal #deleteCatalogModal seFeDataSize="small" [seFeDataActions]="deleteCatalogModalButtons()">
  <div seFeModalContent>
    <div class="delete-catalog-header">
      <se-fe-icon seFeDataName="error" seFeDataSize="800" seFeDataColor="critical"></se-fe-icon>
      <h3>Are you sure you want to delete this catalog?</h3>
    </div>

    @if (catalogRegistrationsRequestState().status === 'loading') {
      <se-fe-spinner [seFeDataSize]="900" [seFeDataCenter]="true"></se-fe-spinner>
    } @else if (catalogRegistrationsRequestState().status === 'failure') {
      <p>{{ catalogRegistrationsRequestState().error!.message }}</p>
      <se-fe-button seFeDataEmphasis="low" (click)="retryCatalogRegistrations()">Retry</se-fe-button>
    } @else if (catalogRegistrationsRequestState().registrations.length) {
      @if (selectedCatalog(); as catalog) {
        <p>
          By deleting the
          <strong>{{ catalog.name }}</strong>
          catalog, the catalog will also be removed from the following registrations:
        </p>
        <ul>
          @for (registration of catalogRegistrationsRequestState().registrations; track registration.id) {
            <li>{{ registration.name }}</li>
          }
        </ul>
      }
    }
  </div>
</se-fe-modal>
